import { render, staticRenderFns } from "./StreamMetrics.vue?vue&type=template&id=ca97d9ca&"
import script from "./StreamMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./StreamMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports